
import { Component, Vue } from 'vue-property-decorator';
import SearchBar from '@/components/home/SearchBar.vue';
import ReportList from '@/components/search/ReportList.vue';
@Component({
  components: {
    SearchBar,
    ReportList,
  },
})
export default class SearchView extends Vue {
  searchStyle = {
    width: '5.98rem',
  };
  searchValue(val: string) {
    const report = this.$refs.report as any;
    report.searchValue(val);
  }
  clearValue() {
    const report = this.$refs.report as any;
    report.clearValue();
  }
  created() {
    this.$syncFollow();
    // 监听onshow协议触发更新关注状态
    window.registerWebListener('onShow', () => {
      this.$syncFollow();
    });
  }
}
